var app = angular.module('app', [
  'ui.router', 'ui.bootstrap', 'highcharts-ng', 'ngSanitize', 'ngResource', 'ngCachedResource',
  'ngTouch', 'angularMoment', 'perfect_scrollbar', 'ui.select', 'policyModule', 'dbl-analytics',
  'navigationPaneModule', 'core', 'navigationHeaderModule', 'mainContentArea', 'leftPaneModule',
  'rightPaneModule', 'previewBannerModule', 'ngIdle', 'angulartics',
  'ngCookies', 'concept-map', 'EdxFtue', 'edxManage', 'edxPd', 'EdxReport', 'edxResources', 'edxComponents']);

app.run(['navigation', '$rootScope', '$modalStack', 'Idle', 'localeService', function ($navigation, $rootScope, $modalStack, $idle, localeService) {

  /* onLoad
   * Events to execute immediately on load. Such as fetching the customer and
   * loading other data that is needed immediately.
   */
  var onLoad = function () {
    localeService.setLocaleFromLocalStorage();

    // TODO - when ready, this would be the place for the G2 all in one nav json call
  };
  onLoad();

  function modalChangesUrl(modalStackTop) {
    if (!modalStackTop.value || !modalStackTop.value.modalScope) {
      return false;
    }

    return modalStackTop.value.modalScope.modalChangesUrl;
  }

  // dismiss active modal on back button.  This handles all modals
  // except for ones like teacher settings modal which manipulate the url.
  // See $stateChangeStart below.
  $rootScope.$on('$locationChangeStart', function (event, newUrl, oldUrl, newState) {
    var top = $modalStack.getTop();
    // this triggers in some cases before page data finishes loading and after FTUE modal pops
    // Need to not dismiss the FTUE modal in that case, and it should only ever be the only one up when it is
    if (top && !modalChangesUrl(top) && !$rootScope.AUTO_SHOW_FTUE) {
      $modalStack.dismiss(top.key);
      event.preventDefault();
    }
  });

  // Dismiss active modal on back button.  This handles
  // modals that manipulate the url.  Such modals
  // would automatically close themselves if $locationChangeStart was solely
  // used to manage back botton close.  The teacher settings modal uses notify:false
  // to change state, so
  // $statChangeStart is not fired when it updates the url.
  $rootScope.$on('$stateChangeStart', function () {
    var top = $modalStack.getTop();
    // this triggers in some cases before page data finishes loading and after FTUE modal pops
    // Need to not dismiss the FTUE modal in that case, and it should only ever be the only one up when it is
    if (top && modalChangesUrl(top) && !$rootScope.AUTO_SHOW_FTUE) {
      $modalStack.dismiss(top.key);
      event.preventDefault();
    }
  });

  // logs user out after a period of inactivity
  $idle.watch();

}]);
